'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

GroupsPopulationService=function(_BaseService){_inherits(GroupsPopulationService,_BaseService);function GroupsPopulationService(){_classCallCheck(this,GroupsPopulationService);return _possibleConstructorReturn(this,_BaseService.apply(this,arguments))}GroupsPopulationService.prototype.
populate=function populate(groupTree,personIndex){let personTransformFn=arguments.length>2&&arguments[2]!==void 0?arguments[2]:void 0;
return treeUtils.map(groupTree,function(group){
let keysToCopy=_.keys(group).filter(function(key){return key!=='personIds'&&key!=='children'});
let populated=_.pick(group,keysToCopy);

populated.persons=group.personIds.
map(function(id){return personIndex[id]}).
filter(function(person){return _.exists(person)}).
map(function(p){return _.exists(personTransformFn)?personTransformFn(group,_.cloneDeep(p)):p});

return populated;
});
};return GroupsPopulationService}(BaseService);


module.exports=GroupsPopulationService;
//# sourceMappingURL=groupsPopulationService.js.map
